// extracted by mini-css-extract-plugin
export var header = "PageHeader-module__header___RyJ57";
export var headerContent = "PageHeader-module__headerContent___4bLCD";
export var headerTag = "PageHeader-module__headerTag___RStvu";
export var heading = "PageHeader-module__heading___+aU1h";